export const convertBytesToKilobytes = size => Math.ceil(size / 1024);
